var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgParkingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 71,
    viewBox: "0 0 50 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.1406 0H5.02902C2.26272 0 0 2.26286 0 5.02903V67.3946C0 69.1558 1.50857 70.6643 3.2697 70.6643H12.0722C13.8334 70.6643 15.3419 69.1557 15.3419 67.3946V49.0374H25.1494C39.7349 49.0374 51.3018 36.2127 49.2918 21.3744C47.5271 9.05172 36.462 0 24.1406 0ZM24.8949 33.6971H15.0874V15.3399H24.8949C29.9239 15.3399 34.199 19.3639 34.199 24.644C34.199 29.9241 29.9242 33.6971 24.8949 33.6971Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParkingIcon);
export default __webpack_public_path__ + "static/media/parking-icon.ca9309d0ff72824df990ac2f04bcf81b.svg";
export { ForwardRef as ReactComponent };